import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';

export default mutatorAction('removeNotificationUpdateLog', () => {
    getStore().notificationUpdateLogs.shift();
});
